(function () {
  if (window.__alankiCartSyncInit) return;
  window.__alankiCartSyncInit = true;

  const CART_ENDPOINTS = ['/cart/add.js', '/cart/change.js', '/cart/update.js'];

  function updateBadgeDOM(count) {
    // Try every common selector pattern for cart count badges
    const selectors = [
      '[data-cart-count]',
      '[data-cart-item-count]',
      '.cart-count',
      '.cart-item-count',
      '.header__cart-count',
      '.cart-count-bubble',
      '.cart-bubble',
      '[aria-label*="cart"] .count',
      '.icon-cart .count',
      '.cart-icon__count',
      '.alanki-cart-count',
      '.cart__count',
    ];

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
        if (count > 0) {
          el.removeAttribute('hidden');
          el.setAttribute('aria-hidden', 'false');
        } else {
          el.setAttribute('aria-hidden', 'true');
        }
      });
    });

    // Also try data attributes
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-cart-count', count);
    });
  }

  function syncCartCount() {
    fetch('/cart.js')
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js failed: ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        var count = cart.item_count || 0;

        // 1. Directly update the DOM
        updateBadgeDOM(count);

        // 2. Fire multiple event formats to cover all bases
        var detail = { itemCount: count, cart: { totalQuantity: count } };

        ['cartLinesUpdate', 'cart:updated', 'cart:refresh', 'product:added',
         'shopify:cart:lines:update', 'cart-update'].forEach(function (name) {
          try {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
          } catch (e) {}
        });

        // 3. Try Shopify's section rendering API to re-render the header
        // This forces Shopify to re-render the cart bubble via section rendering
        var headerSection = document.querySelector('[id^="shopify-section-"][id*="header"]');
        if (headerSection) {
          var sectionId = headerSection.id.replace('shopify-section-', '');
          fetch('/?sections=' + encodeURIComponent(sectionId))
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              if (sections[sectionId]) {
                var tmp = document.createElement('div');
                tmp.innerHTML = sections[sectionId];
                // Only update the cart count element, not the whole header
                var newBadge = tmp.querySelector('[data-cart-count], .cart-count, .cart-item-count, .alanki-cart-count');
                var oldBadge = document.querySelector('[data-cart-count], .cart-count, .cart-item-count, .alanki-cart-count');
                if (newBadge && oldBadge) {
                  oldBadge.innerHTML = newBadge.innerHTML;
                  oldBadge.style.display = count > 0 ? '' : 'none';
                }
              }
            })
            .catch(function () {});
        }
      })
      .catch(function (err) {
        console.warn('[alanki-cart-sync] Error:', err);
      });
  }

  function isCartEndpoint(url) {
    if (!url) return false;
    return CART_ENDPOINTS.some(function (ep) { return String(url).includes(ep); });
  }

  // Intercept fetch
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = (input instanceof Request) ? input.url : input;
    var promise = _fetch.apply(this, arguments);
    if (isCartEndpoint(url)) {
      promise.then(function (res) { if (res.ok) syncCartCount(); }).catch(function () {});
    }
    return promise;
  };

  // Intercept XHR
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._alankiUrl = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (isCartEndpoint(this._alankiUrl)) {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) syncCartCount();
      });
    }
    return _send.apply(this, arguments);
  };

  // Listen for any theme-dispatched cart events
  ['cart:updated', 'cart:refresh', 'product:added'].forEach(function (name) {
    document.addEventListener(name, syncCartCount);
  });

  // Initial sync
  syncCartCount();
})();
